import React from "react";
import { Link } from "react-router-dom";
import { useAppContext } from "../../../../../../../context/AppContext";

export default function PurchaseKey() {
    const { appData } = useAppContext();
    return (
        <>
            {appData?.metadata?.features?.includes("buykeys") ? (
                <div className="card">
                    <div className="card-body text-center ai-icon  text-primary">
                        <svg id="rocket-icon" className="my-2" viewBox="0 0 24 24" width="80" height="80" stroke="currentColor" strokeWidth="1" fill="none" strokeLinecap="round" strokeLinejoin="round">
                            <path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"></path>
                            <line x1="3" y1="6" x2="21" y2="6"></line>
                            <path d="M16 10a4 4 0 0 1-8 0"></path>
                        </svg>
                        <h4 className="my-2">Running Low on Keys ?</h4>
                        <Link to="/shop/robotrader-licence-keys" className="btn my-2 btn-primary btn-lg px-4"><i className="fa fa-usd"></i> Purchase keys</Link>
                    </div>
                </div>
            ):(
                
                <div className="card">
                    <div className="card-body text-center ai-icon  text-primary">
                        
                        <img src={appData?.logo} alt="Logo" className="rounded mb-3" width="80" height="80" />
                        <h4 className="my-2">Welcome to {appData?.name}</h4>
                        <p className="text-muted">All system features are running smoothly.</p>
                    </div>
                </div>
                
            )}
        </>
    );
}